import { features } from 'reactApp/mail-features';

export const forWorkUpgradeTariff = features.getAsString('for-work-upgrade-tariff') || '';

/** id промо - для включения нужно будет включать фичу app.enableFeature('3promo-enable-upgrade-for-work-modal') */
export const PROMO_ID = 'upgrade-for-work-modal';

export const config = features.getAsJSON(`${PROMO_ID}-config`) || {
    showLimit: 259200,
    closeLimit: 3,
    showInterval: 3,
};
